import { render, staticRenderFns } from "./ResourceControls.vue?vue&type=template&id=6ad12262&"
import script from "./ResourceControls.vue?vue&type=script&lang=js&"
export * from "./ResourceControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports